// extracted by mini-css-extract-plugin
module.exports = {"loader":"s3k_","rotating":"s1V0"};